import { Element, htmlToDOM } from 'html-react-parser';

type Node = { type: string; value?: string; children?: Node[]; data?: unknown; url?: string };

export default function remarkDefinitions() {
  return (tree: Node) => {
    const visit = (parent: Node, insideLink = false) => {
      insideLink = insideLink || parent.type === 'link';
      const children = parent.children;
      if (!children) return;
      for (let index = 0; index < children.length; index++) {
        const node = children[index];
        if (node.type !== 'html') {
          visit(node, insideLink);
          continue;
        }
        let markup = node.value || '';
        let count = 1;
        if (
          /^<popover\s[^>]*>$/i.test(markup) &&
          children[index + 1]?.type === 'text' &&
          children[index + 2]?.value === '</popover>'
        ) {
          markup += `${children[index + 1].value}</popover>`;
          count = 3;
        }
        const parsed = htmlToDOM(markup);
        if (
          !parsed.some((element) => element instanceof Element && element.name === 'popover') ||
          parsed.some(
            (element) =>
              element.type !== 'text' &&
              (!(element instanceof Element) ||
                element.name !== 'popover' ||
                !element.attribs.definition?.trim() ||
                !element.children.length ||
                element.children.some((child) => child.type !== 'text')),
          )
        )
          continue;
        const replacements: Node[] = parsed.map((element) => {
          if (!(element instanceof Element))
            return { type: 'text', value: element.type === 'text' ? element.data : '' };
          const term = element.children
            .map((child) => (child.type === 'text' ? child.data : ''))
            .join('');
          const definition = element.attribs.definition.trim();
          const text = { type: 'text', value: term };
          return insideLink
            ? { type: 'text', value: `${term} (${definition})` }
            : {
                type: 'link',
                url: '#',
                children: [text],
                data: {
                  hName: 'span',
                  hProperties: { 'data-definition': definition, 'data-term': term },
                },
              };
        });
        children.splice(index, count, ...replacements);
        index += replacements.length - 1;
      }
    };
    visit(tree);
  };
}
